'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import Raven from 'Raven';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import * as GoodSubTypes from 'marketplace-lib/constants/GoodSubTypes';
import * as GoodTypes from 'marketplace-lib/constants/GoodTypes';
import StripePurchaseErrors from '../constants/StripePurchaseErrors';
import ProductMarketplaceClient from '../data/ProductMarketplaceClient';
import { isProd } from '../utils/env';
import { getRedirectToDetails, getPurchaseButtonClassNames } from '../utils/utils';
import { Screens } from '../lib/usage/constants';
import HubspotUrls from '../constants/HubspotUrls';

var getI18nKey = function getI18nKey(path) {
  return "MarketplaceUI.goodDetailsPage.purchaseButton." + path;
};

var UpgradePointButton = function UpgradePointButton(props) {
  var children = props.children,
      upgradeKey = props.upgradeKey,
      rest = _objectWithoutProperties(props, ["children", "upgradeKey"]);

  var _useUpgradeModal = useUpgradeModal(upgradeKey),
      openUpgradeModal = _useUpgradeModal.openUpgradeModal;

  return React.createElement(UIButton, Object.assign({}, rest, {
    onClick: openUpgradeModal,
    use: "primary"
  }), children, React.createElement(UILockBadge, null));
};

export default createReactClass({
  displayName: "PurchaseButton",
  propTypes: {
    goodNameUrlToken: PropTypes.string.isRequired,
    hasContentAccess: PropTypes.bool.isRequired,
    hasInstallAccess: PropTypes.bool.isRequired,
    hasEmailAccess: PropTypes.bool.isRequired,
    hasRequiredEmailSubscription: PropTypes.bool.isRequired,
    hasRequiredMarketingHubSubscription: PropTypes.bool.isRequired,
    isCustomer: PropTypes.bool.isRequired,
    isGoodProvider: PropTypes.bool.isRequired,
    isEmailGood: PropTypes.bool.isRequired,
    isFree: PropTypes.bool.isRequired,
    isPurchased: PropTypes.bool.isRequired,
    isRefunded: PropTypes.bool.isRequired,
    isTrial: PropTypes.bool.isRequired,
    newVersionAvailable: PropTypes.bool.isRequired,
    goodId: PropTypes.number.isRequired,
    goodName: PropTypes.string.isRequired,
    goodSubType: PropTypes.oneOf(Object.values(GoodSubTypes)).isRequired,
    goodType: PropTypes.oneOf(Object.values(GoodTypes)).isRequired,
    payWithStripe: PropTypes.bool.isRequired,
    previewMode: PropTypes.bool.isRequired,
    price: PropTypes.number.isRequired,
    providerUrlToken: PropTypes.string.isRequired,
    purchaseGoodWithPaypal: PropTypes.func.isRequired,
    purchaseGoodWithStripe: PropTypes.func.isRequired,
    reinstallGood: PropTypes.func.isRequired,
    trackPurchasedGood: PropTypes.func.isRequired,
    triggerPurchaseErrorModalOpening: PropTypes.func.isRequired
  },
  calculatePurchasePriceCents: function calculatePurchasePriceCents(purchasePriceDollars) {
    return purchasePriceDollars * 100;
  },
  getRequestDataCommonToStripeAndPaypal: function getRequestDataCommonToStripeAndPaypal() {
    return {
      goodId: this.props.goodId,
      price: this.props.price,
      purchaseThruCreatePage: false
    };
  },
  getStripePublishableKey: function getStripePublishableKey() {
    if (isProd()) {
      return 'pk_live_T0AlYwoUk5DCTeoQa3F5cSWs';
    }

    return 'pk_test_kLD9iKqWosWefMxPIXAU6rw1';
  },
  handlePurchaseButtonClick: function handlePurchaseButtonClick() {
    var _this$props = this.props,
        goodId = _this$props.goodId,
        goodName = _this$props.goodName,
        goodNameUrlToken = _this$props.goodNameUrlToken,
        goodSubType = _this$props.goodSubType,
        hasRequiredEmailSubscription = _this$props.hasRequiredEmailSubscription,
        isCustomer = _this$props.isCustomer,
        isEmailGood = _this$props.isEmailGood,
        isFree = _this$props.isFree,
        newVersionAvailable = _this$props.newVersionAvailable,
        payWithStripe = _this$props.payWithStripe,
        providerUrlToken = _this$props.providerUrlToken,
        purchaseGoodWithPaypal = _this$props.purchaseGoodWithPaypal,
        purchaseGoodWithStripe = _this$props.purchaseGoodWithStripe,
        reinstallGood = _this$props.reinstallGood;

    if (isEmailGood && !hasRequiredEmailSubscription) {
      return;
    }

    if (newVersionAvailable) {
      reinstallGood(goodId, goodName, true);
    } else if (!isCustomer) {
      window.location = getRedirectToDetails(providerUrlToken, goodNameUrlToken);
    } else if (isFree) {
      var data = this.getRequestDataCommonToStripeAndPaypal();
      this.trackPurchase(goodSubType, 0, 'free');
      purchaseGoodWithStripe(data);
    } else if (payWithStripe) {
      this.handleStripePurchase();
    } else {
      var _data = this.getRequestDataCommonToStripeAndPaypal();

      purchaseGoodWithPaypal(_data);
    }
  },
  handleStripePurchase: function handleStripePurchase() {
    var _this = this;

    var _this$props2 = this.props,
        goodId = _this$props2.goodId,
        triggerPurchaseErrorModalOpening = _this$props2.triggerPurchaseErrorModalOpening;

    if (!window.Stripe) {
      triggerPurchaseErrorModalOpening(StripePurchaseErrors.STRIPE_CHECKOUT_FAILED);
      return;
    }

    ProductMarketplaceClient.getStripeSessionId(goodId).then(function (_ref) {
      var connectedAccountId = _ref.connectedAccountId,
          sessionId = _ref.sessionId;
      var stripe = window.Stripe(_this.getStripePublishableKey(), {
        stripeAccount: connectedAccountId
      });
      return stripe.redirectToCheckout({
        sessionId: sessionId
      }).then(function (result) {
        FloatingAlertStore.addAlert({
          message: result.error.message,
          titleText: getI18nKey('stripeRedirectError.titleText'),
          type: 'danger'
        });
      });
    }).catch(function () {
      triggerPurchaseErrorModalOpening(StripePurchaseErrors.STRIPE_CHECKOUT_FAILED);
    });
  },
  trackPurchase: function trackPurchase(goodSubType, price, paymentType) {
    var isTrial = this.props.isTrial;
    this.props.trackPurchasedGood(Screens.DETAILS, price, goodSubType, {
      payment_type: paymentType,
      is_trial: isTrial
    });
  },
  renderMessage: function renderMessage() {
    var _this$props3 = this.props,
        goodSubType = _this$props3.goodSubType,
        isPurchased = _this$props3.isPurchased,
        isRefunded = _this$props3.isRefunded,
        newVersionAvailable = _this$props3.newVersionAvailable,
        price = _this$props3.price;

    if (newVersionAvailable) {
      return React.createElement(FormattedMessage, {
        message: getI18nKey('installUpdate')
      });
    }

    var goodSubTypeKey;

    if (goodSubType === GoodSubTypes.PACKS) {
      goodSubTypeKey = 'pack';
    } else if (goodSubType === GoodSubTypes.CUSTOM_MODULE) {
      goodSubTypeKey = 'module';
    } else if (goodSubType === GoodSubTypes.CMS_THEME) {
      goodSubTypeKey = 'theme';
    } else {
      goodSubTypeKey = 'indivTemplate';
    }

    if (isPurchased && !isRefunded) {
      return React.createElement(FormattedMessage, {
        message: getI18nKey(goodSubTypeKey + ".installed")
      });
    }

    if (!price) {
      return React.createElement(FormattedMessage, {
        message: getI18nKey(goodSubTypeKey + ".free")
      });
    }

    return React.createElement(FormattedReactMessage, {
      message: getI18nKey(goodSubTypeKey + ".paid"),
      options: {
        price: React.createElement(FormattedCurrency, {
          currencyCode: "USD",
          simplifyCurrency: true,
          value: price
        })
      }
    });
  },
  render: function render() {
    var _this$props4 = this.props,
        goodName = _this$props4.goodName,
        goodNameUrlToken = _this$props4.goodNameUrlToken,
        goodType = _this$props4.goodType,
        hasContentAccess = _this$props4.hasContentAccess,
        hasInstallAccess = _this$props4.hasInstallAccess,
        hasEmailAccess = _this$props4.hasEmailAccess,
        hasRequiredEmailSubscription = _this$props4.hasRequiredEmailSubscription,
        hasRequiredMarketingHubSubscription = _this$props4.hasRequiredMarketingHubSubscription,
        isCustomer = _this$props4.isCustomer,
        isGoodProvider = _this$props4.isGoodProvider,
        isEmailGood = _this$props4.isEmailGood,
        isFree = _this$props4.isFree,
        isPurchased = _this$props4.isPurchased,
        isRefunded = _this$props4.isRefunded,
        newVersionAvailable = _this$props4.newVersionAvailable,
        previewMode = _this$props4.previewMode,
        price = _this$props4.price,
        providerUrlToken = _this$props4.providerUrlToken;

    if (!isFree && !price || isFree && price) {
      if (!previewMode) {
        Raven.captureMessage("purchase-button error for " + goodName + " with price of " + price);
      }

      return null;
    }

    var isEmailLockedFeature = isEmailGood && !isPurchased && !hasRequiredEmailSubscription;
    var isDisabled = !isCustomer || isGoodProvider || previewMode || !hasInstallAccess || isPurchased && !(isRefunded || newVersionAvailable) || isEmailGood && !hasEmailAccess || !isEmailGood && !hasContentAccess || !isEmailGood && !hasRequiredMarketingHubSubscription;
    var purchaseButton = React.createElement(UIButton, {
      className: getPurchaseButtonClassNames(previewMode),
      disabled: isDisabled,
      onClick: this.handlePurchaseButtonClick,
      use: "primary"
    }, this.renderMessage(), isEmailLockedFeature && React.createElement(UILockBadge, null));

    if (isCustomer && isEmailLockedFeature) {
      return React.createElement(UITooltip, {
        placement: "bottom left",
        title: React.createElement(FormattedMessage, {
          message: getI18nKey('tooltip.freeOrStarterEmail')
        })
      }, React.createElement(UpgradePointButton, {
        upgradeKey: "marketplace-marketing-professional-email"
      }, this.renderMessage()));
    }

    if (isCustomer && !isEmailGood && !isPurchased && !hasRequiredMarketingHubSubscription) {
      return React.createElement(UITooltip, {
        placement: "bottom left",
        title: React.createElement(FormattedMessage, {
          message: getI18nKey('tooltip.missingRequiredMarketingHubSubscription')
        })
      }, React.createElement(UpgradePointButton, {
        upgradeKey: "marketplace-marketing-professional"
      }, this.renderMessage()));
    }

    var tooltip;

    if (isGoodProvider) {
      tooltip = React.createElement(FormattedJSXMessage, {
        message: getI18nKey('tooltip.providerPermission_jsx'),
        elements: {
          Link: UILink
        },
        options: {
          anotherAccountLink: getRedirectToDetails(providerUrlToken, goodNameUrlToken),
          hubspotFreeLink: HubspotUrls.HUBSPOT_FREE + "?hubs_content=" + window.location.href
        }
      });
    } else if (isCustomer) {
      if (!isPurchased) {
        if (isEmailGood && !hasEmailAccess) {
          tooltip = React.createElement(FormattedMessage, {
            message: getI18nKey('tooltip.emailPermission')
          });
        } else if (!isEmailGood && !hasContentAccess) {
          tooltip = React.createElement(FormattedMessage, {
            message: getI18nKey('tooltip.contentPermission')
          });
        } else if (!hasInstallAccess) {
          tooltip = React.createElement(FormattedMessage, {
            message: getI18nKey('tooltip.marketplacePermission')
          });
        } else if (!isDisabled) {
          tooltip = React.createElement(FormattedMessage, {
            message: getI18nKey('tooltip.portalLicense'),
            options: {
              portalId: "" + PortalIdParser.get(),
              goodType: unescapedText("MarketplaceUI.goodType." + goodType + ".sentence", {
                count: 1
              })
            }
          });
        }
      }
    }

    return React.createElement(UITooltip, {
      disabled: !tooltip,
      placement: "bottom left",
      title: tooltip
    }, purchaseButton);
  }
});